<div class="dialog-container">
  <h2 mat-dialog-title>Record Bank Deposit</h2>
  <div mat-dialog-content>
    <p class="dialog-message">
      Enter the deposit details for your bank account
    </p>
    
    <form [formGroup]="depositForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Amount</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="amount" 
          required numberFormat>
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(depositForm.get('amount')?.hasError('required')) {
          <mat-error>
            Amount is required
          </mat-error>
        }
        @if(depositForm.get('amount')?.hasError('min')) {
          <mat-error>
            Amount must be greater than $0.01
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Date</mat-label>
        <input 
          matInput 
          [matDatepicker]="picker" 
          formControlName="date"
          required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if(depositForm.get('date')?.hasError('required')) {
          <mat-error>
            Date is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category" required>
          @for (category of allCategories; track category) {
            <mat-option [value]="category">
              {{ category }}
            </mat-option>
          }
        </mat-select>
        <mat-hint>Select a transaction category</mat-hint>
        @if(depositForm.get('category')?.hasError('required')) {
          <mat-error>
            Category is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Contact</mat-label>
        <mat-select formControlName="contact_id" required>
          <mat-option [value]="selfContact()?.id">
            {{ selfContact()?.first_name }} {{ selfContact()?.last_name }}
          </mat-option>
          @for (contact of contacts(); track contact.id) {
            <mat-option [value]="contact.id">
              {{ contact.organization }}
            </mat-option>
          }
        </mat-select>
        @if(depositForm.get('contact_id')?.hasError('required')) {
          <mat-error>
            Contact is required
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  
  <div mat-dialog-actions align="end">
    <button 
      mat-button 
      type="button" 
      (click)="onCancel()">
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      type="submit" 
      [disabled]="depositForm.invalid" 
      (click)="onSubmit()">
      <span>Record Deposit</span>
    </button>
  </div>
</div>